export default {
    Cancel: 'Cancel',
    CheckAll: 'CheckAll',
    Confirm: 'Confirm',
    HasBeenselected: 'Selected:',
    NoInformations: 'No relevant information was matched',
    Orgs: 'Departments',
    ResultNum: '',
    SearchOrgUserRole: 'Search Orgnization/User',
    SearchResult: 'result ',
    SelectOrg: 'Select Department',
    SelectUser: 'Select User',
    Subordinate: 'Expand',
    TurnBack: 'Back',
    UserAndOrg: 'Select Department/User',
    Users: 'Users',
    SearchOrg: 'Search Organization',
    SearchNameAccount: 'Search Name/Account',
    WaitUntilDataReturn: 'Please wait until data returned',
    Loading: 'loading'
};
